export interface EventDataBase<TResult> {
    transactionID: string;
    action: string;
    result: TResult;
    status: EventActionResult;
};

export enum EventActionResult{
    Unknown = 'Unknown',
    Ok = 'Ok',
    Warning = 'Warning',
    Error = 'Error',
    Unauthorized = 'Unauthorized'
}